import React from "react";
import { Route, Routes } from "react-router-dom";
import Tabs from "@cs/components/src/Tabs";
import ConfigureOrganizationCreateScreen from "../configureOrganization/ConfigureOrganizationCreateScreen";
import ConfigureOrganizationListScreen from "../configureOrganization/ConfigureOrganizationListScreen";
import ConfigurePluginScriptEditScreen from "../configurePluginOrScript/ConfigurePluginScriptEditScreen";
import ConfigurePluginScriptListScreen from "../configurePluginOrScript/ConfigurePluginScriptListScreen";
import { Settings } from "react-feather";
import ConfigureOrganizationEditScreen from "../configureOrganization/ConfigureOrganizationEditScreen";
import UserListScreen from "../users/UserListScreen";
import UserEditScreen from "../users/UserEditScreen";

const tabs = [
  { key: "organization", label: "Organizations" },
  { key: "plugin", label: "Plugins" },
  { key: "script", label: "Scripts" },
  { key: "user", label: "Users" },
];

const ConfigRouter = () => {
  return (
    <div>
      <Tabs tabs={tabs} icon={Settings} link />
      <Routes>
        <Route
          path="organization"
          element={<ConfigureOrganizationListScreen />}
        />
        <Route
          path="organization/:id"
          element={<ConfigureOrganizationEditScreen />}
        />
        <Route
          path="organization/new"
          element={<ConfigureOrganizationCreateScreen />}
        />
        <Route path="user" element={<UserListScreen />} />
        <Route path="user/new" element={<UserEditScreen />} />
        <Route path="user/:slackId" element={<UserEditScreen />} />
        <Route path=":type" element={<ConfigurePluginScriptListScreen />} />
        <Route
          path=":type/:id/*"
          element={<ConfigurePluginScriptEditScreen />}
        />
      </Routes>
    </div>
  );
};

export default ConfigRouter;
